import { render, staticRenderFns } from "./AvailableOtherLaboursMain.vue?vue&type=template&id=407c4565"
import script from "./AvailableOtherLaboursMain.vue?vue&type=script&lang=js"
export * from "./AvailableOtherLaboursMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports